import {  GET_CLIENT_CONTACT_COLLECTION } from '../../constants/reducerTypes';

const initialState = {};
const clientContactReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_CONTACT_COLLECTION:
      return {
        ...state,
        clientContactdata: action.payload,
      };
    default:
      return state;
  }
};
export default clientContactReducer;
